import React from "react";
import { toast, ToastType } from "react-toastify";
import { MdError } from "react-icons/md";
import { TiWarning } from "react-icons/ti";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import { convertToLocalDate } from "./date";

const iconSize = "1.5em";

/**
 * Get Toast message depends upon conditions
 * @param {*} message
 * @param {*} title
 * @param {*} toastType
 * @returns
 */
function GetTostMsgComponent(message, title, toastType, useStyledMessage = false, styledMessage = <></>,) {
  return (
    <div className={"row"}>
      {toastType && (
        <div className={"col-xs-1 no-padding"}>
          {toastType == ToastType.ERROR && <MdError size={iconSize} />}
          {toastType == ToastType.SUCCESS && (
            <IoMdCheckmarkCircle size={iconSize} />
          )}
          {toastType == ToastType.INFO && <FaInfoCircle size={iconSize} />}
          {toastType == ToastType.WARNING && <TiWarning size={iconSize} />}
          {toastType == ToastType.DEFAULT && <FaInfoCircle size={iconSize} />}
        </div>
      )}
      {title && (
        <div className={"col-xs-11 toast-title no-padding"}>{title}</div>
      )}
      {toastType && title ? <div className={"col-xs-2"}>&nbsp;</div> : ""}
      { useStyledMessage && styledMessage}
      {!useStyledMessage && <div className={"col-xs-11 toast-sub-message"}>{message}</div>}
    </div>
  );
}

/**
 * show toast message according to parameter inputs.
 * @param {*} message
 * @param {*} toastType
 * @param {*} autoclose
 * @param {*} messageId
 * @param {*} title
 */
export function ShowToast(
  message,
  toastType,
  autoclose = 1000,
  messageId = 0,
  title = "",
  useStyledMessage = false,
  styledMessage = <></>
) {
  if (message) {
    if (!toast.isActive(messageId)) {
      switch (toastType) {
        case ToastType.ERROR:
          toast.error(() => GetTostMsgComponent(message, title, toastType, useStyledMessage, styledMessage), {
            autoClose: autoclose,
            toastId: messageId
          });
          break;
        case ToastType.SUCCESS:
          toast.success(() => GetTostMsgComponent(message, title, toastType), {
            autoClose: autoclose,
            toastId: messageId
          });
          break;
        case ToastType.WARNING:
          toast.warn(() => GetTostMsgComponent(message, title, toastType), {
            autoClose: autoclose,
            toastId: messageId
          });
          break;
        case ToastType.INFO:
          toast.info(() => GetTostMsgComponent(message, title, toastType), {
            autoClose: autoclose,
            toastId: messageId
          });
          break;
        case ToastType.DEFAULT:
        default:
          toast(() => GetTostMsgComponent(message, title, toastType), {
            autoClose: autoclose,
            toastId: messageId
          });
          break;
      }
    }
  }
}

/**
 * Get notification message depends upon conditions
 * @param {*} item
 * @param {*} handelClick
 * @returns
 */
function GetNotificationMsgComponent(item, handelClick) {
  const { title, recordId, message, createdOn } = item;
  return (
    <div className={"row"}>
      <div className={"col-xs-12 notification-header"}>
        {title && (
          <div
            className={"col-xs-11 msg-toast-title no-padding"}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div
          className={"col-xs-1 close-icon"}
          onClick={() => toast.dismiss(recordId)}
        >
          {"X\r"}
        </div>
      </div>
      <div
        className={"col-xs-12 notification-sub-message"}
        dangerouslySetInnerHTML={{ __html: message }}
      />
      <div className={"col-xs-12 notification-sub-message-small"}>
        {"Received on: "}
        {convertToLocalDate(createdOn, "MM/DD/YYYY hh:mm A")}
      </div>
      <div className={"col-xs-12 notification-action"}>
        <div className={"row end-xs"}>
          <div
            onClick={() => {
              handelClick(item, "view", "show");
            }}
            className={"col-xs-auto margin-left decor"}
          >
            <div>{"View"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Show notification
 */
export function ShowNotification(item, autoclose = 8000, handelClick) {
  const options = {
    autoClose: autoclose,
    toastId: item.recordId,
    position: toast.POSITION.BOTTOM_RIGHT,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    hideProgressBar: false
  };
  if (item) {
    if (!toast.isActive(item.recordId)) {
      toast.info(() => GetNotificationMsgComponent(item, handelClick), {
        ...options,
        className: "notification-msg"
      });
    }
  }
}
export const toastType = ToastType;
